import Color from "color";

export const PRIMARY_COLOR: string = "#005680";
export const DARK_MODE: string = "#1D1E2C";

export const useGenerateColor = (color) => {
  return {
    50: Color(color).lighten(0.5).hex(),
    100: Color(color).lighten(0.4).hex(),
    200: Color(color).lighten(0.3).hex(),
    300: Color(color).lighten(0.2).hex(),
    400: Color(color).lighten(0.1).hex(),
    500: Color(color).hex(),
    600: Color(color).darken(0.1).hex(),
    700: Color(color).darken(0.2).hex(),
    800: Color(color).darken(0.3).hex(),
    900: Color(color).darken(0.4).hex(),
    950: Color(color).darken(0.5).hex(),
  };
};
